<template>
  <div id="home">
    <!-- 视频播放器：增加 Webkit 兼容属性防止微信强制全屏 -->
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      x5-video-player-type="h5-page"
      webkit-playsinline="true"
    ></video-player>

    <img class="slogan" src="@/assets/slogan.png" />

    <div class="scroll-more">
      <b>
        <i class="el-icon-arrow-down" style="font-size: 30px"></i>
      </b>
      <p>滑动探索更多</p>
    </div>
    <!-- 最新资讯 -->
    <div class="block1">
      <div class="b-titlebar bsb">
        <div class="bt-left">最新资讯</div>
      </div>
      <ul class="nav">
        <li><router-link to="/newsCenter?type=0">公司新闻</router-link></li>
        <li><router-link to="/newsCenter?type=1">行业资讯</router-link></li>
      </ul>
      <div class="cc">
        <div class="c1" v-if="newsList[0]" @click="navTo(newsList[0])">
          <img
            :src="newsList[0].coverUrl"
            style="object-fit: cover; width: 100%"
          />
          <div class="news">
            <p class="tit">{{ newsList[0].title }}</p>
            <p class="tim">{{ newsList[0].publishTime }}</p>
            <p class="des">{{ newsList[0].excerpt }}</p>
          </div>
        </div>
        <div class="c2">
          <div
            class="news"
            v-for="index in [1, 2, 3, 4]"
            :key="index"
            v-if="newsList[index]"
            @click="navTo(newsList[index])"
          >
            <p class="tit">{{ newsList[index].title }}</p>
            <p class="tim">{{ newsList[index].publishTime }}</p>
            <p class="des">{{ newsList[index].excerpt }}</p>
            <div class="line" v-if="index < 4"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业领域 -->
    <div class="block2">
      <div class="b-titlebar bsb">
        <div class="bt-left">
          {{
            $store.state.config["home_industry"]
              ? $store.state.config["home_industry"].name
              : "行业领域"
          }}
        </div>
        <div class="bt-right">
          <router-link to="/industry" style="color: #504f4f"
            >更多 ></router-link
          >
        </div>
      </div>
      <div class="dd">
        <div
          class="d1"
          v-for="(item, index) in $store.state.config['home_industry']
            ? $store.state.config['home_industry'].children
            : []"
          :key="index"
        >
          <img :src="item.img" class="d1_img1" />
          <img src="../assets/img/meng.png" class="d1_img2" />
          <p class="d1_p1">{{ item.name }}</p>
          <p class="d1_p2">{{ item.label1 }}</p>
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="block3">
      <div class="b-titlebar bsb">
        <div class="bt-left" style="color: white">
          {{
            $store.state.config["home_about"]
              ? $store.state.config["home_about"].name
              : "关于我们"
          }}
        </div>
      </div>
      <div class="ee">
        <div
          class="e1"
          v-html="
            $store.state.config['home_about']
              ? $store.state.config['home_about'].content
              : ''
          "
        ></div>
        <div class="e2">
          <img
            :src="
              $store.state.config['home_about']
                ? $store.state.config['home_about'].img
                : ''
            "
          />
        </div>
      </div>
      <div class="more">
        <router-link to="/about" style="color: white">了解更多 ></router-link>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="block4">
      <div class="b-titlebar bc">
        <div class="bt-center" id="cooperation">合作伙伴</div>
      </div>
      <div class="nav">
        <el-button-group>
          <el-button
            icon="el-icon-s-help"
            style="color: #182876"
            @click="showLogo = 'ziyuan'"
            >合作资源</el-button
          >
          <el-button
            icon="el-icon-s-opportunity"
            style="color: #182876"
            @click="showLogo = 'kehu'"
            >合作客户</el-button
          >
        </el-button-group>
      </div>
      <div class="logo" v-if="showLogo == 'ziyuan'">
        <div
          class="logo-item"
          v-for="(item, index) in $store.state.config['home_cooperation_ziyuan']
            ? $store.state.config['home_cooperation_ziyuan'].children
            : []"
          :key="index"
        >
          <img class="logo-img" :src="item.img" :alt="item.name" />
        </div>
      </div>
      <div class="logo" v-if="showLogo == 'kehu'">
        <div
          class="logo-item"
          v-for="(item, index) in $store.state.config['home_cooperation_kehu']
            ? $store.state.config['home_cooperation_kehu'].children
            : []"
          :key="index"
        >
          <img class="logo-img" :src="item.img" :alt="item.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { listArticle } from "@/api/article";

export default {
  name: "Home",
  components: {
    videoPlayer,
  },
  data() {
    return {
      showLogo: "ziyuan",
      newsList: [],
      playerOptions: {
        autoplay: true,
        muted: true,
        loop: true,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "https://axwl-mhwz.oss-cn-shenzhen.aliyuncs.com/filename/axvideo.mp4",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: false,
      },
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      listArticle({ pageNum: 1, pageSize: 10 })
        .then((res) => {
          this.newsList = res.rows || [];
        })
        .catch((err) => {
          console.error("新闻列表加载失败:", err);
        });
    },
    navTo(item) {
      if (!item) return;
      if (item.originalType === "0") {
        // 微信内 window.open 可能会被拦截，加一个兜底
        if (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        ) {
          this.$router.push({
            path: `/newsCenter/news`,
            query: { id: item.id },
          });
        } else {
          let routeData = this.$router.resolve({
            path: `/newsCenter/news`,
            query: { id: item.id },
          });
          window.open(routeData.href, "_blank");
        }
      } else if (item.originalType === "1") {
        window.location.href = item.exUrl;
      }
    },
  },
};
</script>

<style scoped>
/* ==================== PC 端样式（继承并优化原有样式） ==================== */
.block1,
.block2,
.block3,
.block4 {
  padding: 40px 10%;
}
.b-titlebar {
  display: flex;
  flex-direction: row;
}
.bsb {
  justify-content: space-between;
  align-items: center;
}
.bc {
  justify-content: center;
}
.bt-left,
.bt-center {
  font-size: 35px;
  font-weight: 700;
  color: #444444;
}
.bt-right {
  font-size: 20px;
  font-weight: 500;
  color: #504f4f;
}

/* 新闻板块 */
.block1 .nav {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0;
}
.block1 .nav li {
  margin-left: 30px;
  font-size: 20px;
}
.cc {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.cc .c1,
.cc .c2 {
  width: 50%;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}
.cc .c1 {
  margin-right: 10px;
}
.cc .c2 {
  margin-left: 10px;
}
.c2 .line {
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 10px 0;
}
.news {
  padding: 20px;
  cursor: pointer;
}
.news .tit {
  color: #23337f;
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 5px;
}
.news .tim {
  color: #8f8f8f;
  font-size: 14px;
  margin-bottom: 8px;
}
.news .des {
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/* 行业板块 */
.dd {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
.d1 {
  position: relative;
  margin: 15px;
  overflow: hidden;
}
.d1_img1 {
  width: 350px;
  height: 250px;
  object-fit: cover;
  display: block;
}
.d1_img2 {
  width: 100%;
  height: auto;
  position: absolute;
  left: 0;
  bottom: 0;
}
.d1_p1 {
  font-size: 18px;
  font-weight: 600;
  color: white;
  position: absolute;
  bottom: 50px;
  left: 20px;
  z-index: 2;
  margin: 0;
}
.d1_p2 {
  font-size: 14px;
  color: white;
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 2;
  margin: 0;
}

/* 关于我们 */
.block3 {
  background-image: url("../assets/img/bg1.png");
  background-size: cover;
  background-position: center;
}
.ee {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  color: white;
}
.ee .e1 {
  width: 60%;
  font-size: 16px;
  line-height: 32px;
}
.ee .e2 {
  width: 30%;
  margin-left: 10%;
}
.ee .e2 img {
  width: 100%;
  object-fit: cover;
}
.block3 .more {
  width: 140px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  margin-top: 20px;
}

/* 合作伙伴 */
.block4 .nav {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.block4 .logo {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 30px;
}
.logo-item {
  margin: 15px 25px;
  text-align: center;
}
.logo-img {
  height: 60px;
  object-fit: contain;
}

a {
  text-decoration: none;
  color: black;
}
.slogan {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  max-width: 800px;
}
.scroll-more {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.scroll-more b {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 45px;
  height: 45px;
  border: 2px solid #fff;
  border-radius: 50%;
}
.scroll-more p {
  color: white;
  font-size: 14px;
  margin-top: 5px;
}
.scroll-more b i {
  color: white;
  animation: jumpBoxHandler 1.8s infinite;
}

@keyframes jumpBoxHandler {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
}

/* ==================== 移动端响应式样式（屏幕小于 768px 时生效） ==================== */
@media screen and (max-width: 767px) {
  .block1,
  .block2,
  .block3,
  .block4 {
    padding: 30px 5%; /* 缩小两边留白 */
  }

  .bt-left,
  .bt-center {
    font-size: 24px; /* 减小手机端标题字号 */
  }

  /* 新闻部分改为上下单列布局 */
  .cc {
    flex-direction: column;
  }
  .cc .c1,
  .cc .c2 {
    width: 100%;
    margin: 0 0 20px 0;
  }
  .block1 .nav {
    justify-content: flex-start;
    padding-left: 0;
    margin-top: 10px;
  }
  .block1 .nav li {
    margin-right: 20px;
    margin-left: 0;
    font-size: 16px;
  }
  .news {
    padding: 15px;
  }

  /* 行业领域改为单列或双列自适应 */
  .d1 {
    width: 100%; /* 撑满屏幕 */
    margin: 10px 0;
  }
  .d1_img1 {
    width: 100%;
    height: 200px; /* 固定高度，防止被拉伸变形 */
  }

  /* 关于我们改为上下布局 */
  .ee {
    flex-direction: column;
  }
  .ee .e1,
  .ee .e2 {
    width: 100%;
    margin-left: 0;
  }
  .ee .e2 {
    margin-top: 20px;
  }

  /* 合作伙伴 */
  .logo-item {
    margin: 10px;
    width: 40%; /* 一行放两个 logo */
  }
  .logo-img {
    height: 40px;
    width: 100%;
  }

  /* PC端标语居中定位于视频中段 */
  .slogan {
    position: absolute;
    top: 50vw; /* 使用相对于宽度的视口单位，让标语跟随视频比例完全等比缩放 */
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 600px;
    width: 80%;
    height: auto;
    z-index: 3;
    pointer-events: none;
  }
}
</style>
